<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <!-- <breadcrumb :page="$t('form.setting.statusList')"></breadcrumb> -->

        <div class="content">
            <div class="container-fluid pt-5">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>
                <div class="row">
                    <div class="col-md-8">
                        <div class="card">
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.setting.feeList')}}</div>
                            </div>
                            <div class="card-body table-responsive p-0">
                                <table class="table table-hover" v-if="tuitioinfeesarray">
                                    <thead>
                                        <tr class="header">
                                            <th>{{$t('form.setting.inputType')}}</th>
                                            <th>{{$t('form.setting.billing_cycle')}}</th>
                                            <th>{{$t('form.setting.total_fee')}}</th>
                                            <th>{{$t('form.setting.active')}}</th>
                                            <th class="text-right">{{$t('form.setting.action')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(fee, index) in tuitioinfeesarray" :key="index">
                                            <td>{{fee.program_type.name}}</td>
                                            <td class="capital">{{fee.billing_cycle}}</td>
                                            <td>{{fee.total_fee}}</td>
                                            <td>
                                                <b-badge variant="success" v-if="fee.status==true" :set="fee.status = true">{{$t('form.setting.yes')}}</b-badge>
                                                <b-badge variant="danger" v-else :set="fee.status = false">{{$t('form.setting.no')}}</b-badge>
                                            </td>

                                            <td class="text-right">
                                                <button v-if="permissions.editSettingsTuitionfee"
                                                    class="btn btn-info btn-sm" @click="chooseTuitionFee(fee);">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                                <button v-if="permissions.editSettingsTuitionfee"
                                                    class="btn btn-danger btn-sm" @click="remove(fee.id)">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                            </div>

                            <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="2"
                                @paginate="paginate()">
                            </pagination>
                        </div>
                    </div>

                    <div class="col-md-4" >
                        <div class="card" v-if="toggleForm">
                            <div class="card-header bg-light">
                                <div class="card-title" v-if="tuitionFee.ProgramType==null || tuitionFee.ProgramType==''">{{$t('form.setting.editTuitionFee')}}</div>
                                <div class="card-title" v-else-if="tuitionFee.ProgramType!=null || tuitionFee.ProgramType!=''">{{tuitionFee.ProgramType.name}}</div>
                            </div>
                            <div class="card-body">
                            <div class="form-group">
                                    <div class="mt-3">
                                        <b-form-checkbox
                                        :disabled="!edit_enabled"
                                        v-model="tuitionFee.status"
                                        >
                                        Active
                                        </b-form-checkbox>
                                    </div>
                                <div>
                                <div class="form-group mt-3" >
                                    <label>{{$t('form.program.billingCycle')}}</label>
                                    <b-form-select v-model="tuitionFee.BillingCycle" :options="options" @change="changeBillingCycle()" :disabled="tuitionFee.status==false || !edit_enabled"></b-form-select>
                                </div>
                                
                                <div class="form-group d-flex justify-content-between">
                                    <label >{{$t('form.program.issueInvoices')}}</label>
                                    <input v-model="tuitionFee.days" type="number" min=1 max=60 class="form-control mx-2 col-xs-2" :disabled="tuitionFee.status==false || tuitionFee.ProgramType==null">
                                    <label class="mt-2">{{$t('form.program.days')}}</label>
                                    <b-form-select class="mx-2 col-xs-2" v-model="tuitionFee.beforeOrAfter" :options="afterOrBeforeDropdown" :disabled="tuitionFee.status==false || tuitionFee.ProgramType==null"></b-form-select>
                                    <label>{{$t('form.program.cycleStartDate')}}</label>
                                </div>
                                <div class="form-group" v-if="tuitionFee.BillingCycle=='course' && tuitionFee.ProgramType">
                                    <label>{{$t('form.program.noOfCourses')}}</label>
                                    <input class="form-control" v-model="tuitionFee.noOfCourses" type="text" @input="handleNoOfCoursesInput($event.target.value)" maxlength="2" id="noOfCousesID" name="number" :disabled="tuitionFee.status==false || !edit_enabled" />
                                </div>
                                <div class="form-group" v-if="tuitionFee.BillingCycle=='course'">
                                    <label>{{$t('form.program.course')}}  {{$t('form.program.fee')}}</label>
                                    <b-form-input v-model.number="tuitionFee.courseFee" :disabled="tuitionFee.status==false || !edit_enabled"></b-form-input>
                                </div>
                                <div class="form-group" v-if="tuitionFee.BillingCycle=='term'">
                                    <label>{{$t('form.program.noOfSem')}}</label>
                                    <input class="form-control" v-model.number="tuitionFee.noOfSem" :disabled="tuitionFee.status==false || !edit_enabled" type="text" @input="handleInput($event.target.value)" maxlength="2" id="noOfSemID" name="number"/>
                                </div>
                                <template v-if="tuitionFee.BillingCycle=='term' || tuitionFee.noOfSem>=1">
                                    <div class="form-group" v-for="semester in tuitionFee.noOfSem" :key="semester">
                                        <label>{{$t('form.program.termFee')}}{{semester}}</label>
                                        <b-form-input v-model.number="tuitionFee.semesterfees['semester' +semester+'Fee']" :key="semester" :value="tuitionFee.semesterfees['semester' +semester+'Fee']" :disabled="tuitionFee.status==false || !edit_enabled">
                                        </b-form-input> 
                                    </div>
                                </template>
                                <div class="form-group" >
                                    <label>{{$t('form.program.applicationFee')}}</label>
                                    <b-form-input v-model.number="tuitionFee.ApplicationFee" :disabled="tuitionFee.status==false || !edit_enabled"></b-form-input>
                                </div>

                                <div class="form-group">
                                    <label>{{$t('form.program.acceptanceFee')}}</label>
                                    <b-form-input v-model.number="tuitionFee.AcceptanceFee" :disabled="tuitionFee.status==false || !edit_enabled"></b-form-input>
                                </div>

                                <hr>

                                <div class="d-flex justify-content-between" v-if="tuitionFee.ProgramType">
                                    <label>{{$t('form.program.totalCost')}}</label>
                                    <p>{{totalFee | curreny(decimalDigits, decimalPoint, thousandSeparator)}}
                                    </p>
                                </div>
                                </div>
                                </div>

                                <b-button variant="primary" @click="update()" :disabled="tuitionFee.status==false && !edit_enabled">{{$t('button.update')}}</b-button>
                                <b-button variant="outline-primary" @click="cancel()" :disabled="tuitionFee.status==false && !edit_enabled">{{$t('button.cancel')}}</b-button>                            </div>
                        </div>       
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
 import {
        required,
        minLength,
        maxLength,
        alpha,
        between
    } from "vuelidate/lib/validators";
import LoginVue from '../../pages/Login.vue';

    export default {
        props: ['permissions', 'editFormInterval', 'datetimeFormat', 'applicationFee', 'dateFormat', 'decimalDigits',
            'decimalPoint', 'thousandSeparator'
        ],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,
                toggleForm: true,

                pagination: {
                    current_page: 1
                },

                name: '',
                id: '',
                sortOrder: null,
                active: false,

                tuitioinfeesarray:[],
                edit_enabled:false,
                tuitionFee:{   
                    id:null,  
                    ProgramType: null,
                    BillingCycle: null,
                    ApplicationFee: 0,
                    AcceptanceFee: 0,
                    courseFee:0,
                    noOfSem:0,
                    noOfCourses:0,
                    beforeOrAfter:'before',
                    days:null,
                    status:false,
                    semesterfees:{
                    semester1Fee:0,
                    semester2Fee:0,
                    semester3Fee:0,
                    semester4Fee:0,
                    semester5Fee:0,
                    semester6Fee:0,
                    semester7Fee:0,
                    semester8Fee:0,
                    semester9Fee:0,
                    semester10Fee:0,
                    semester11Fee:0,
                    semester12Fee:0,
                    semester13Fee:0,
                    semester14Fee:0,
                    semester15Fee:0,
                    semester16Fee:0,
                    semester17Fee:0,
                    semester18Fee:0,
                    semester19Fee:0,
                    semester20Fee:0,
                    },
                    total:0,
                    sem_total:0
                },
                max_semesters:20,
                options: [
                        { value: 'term', text:this.$t('form.program.byTerm') },
                        { value: 'course', text:this.$t('form.program.byCourse')},
                        
                    ],
                afterOrBeforeDropdown:[{
                text: this.$t('form.program.before'),
                        value: 'before'
                },{
                text: this.$t('form.program.after'),
                        value: 'after'
                }],
                programTypes: [],
     
                }
            },
                validations: {
                        tuitionFee: {
                            ProgramType: {
                                required
                            },
                        },
                    },
        computed: {
            totalFee() {
                if(this.billingCycleChanged==true)return false;
                let total = 0;
                let application_fee = parseFloat(this.tuitionFee.ApplicationFee);
                let acceptance_fee = parseFloat(this.tuitionFee.AcceptanceFee);
                let no_of_courses = parseFloat(this.tuitionFee.noOfCourses);
                let courseFee = parseFloat(this.tuitionFee.courseFee)
        
                if(courseFee=='' || courseFee==NaN || courseFee==null){
                        courseFee=0;
                }
                
                if(no_of_courses=='' || no_of_courses==NaN || no_of_courses==null){
                no_of_courses=1;
                }
                if (courseFee) total += courseFee;
                if (no_of_courses && courseFee) total += courseFee*Number(no_of_courses)-courseFee;
                // Application Fee Add
                if(application_fee=='' || application_fee==NaN || application_fee==null){
                    application_fee=0;
                }
                if (application_fee) total += application_fee;

                // Administration Fee Add
                if(acceptance_fee=='' || acceptance_fee==NaN || acceptance_fee==null){
                        acceptance_fee=0;
                }
                if (acceptance_fee) total += acceptance_fee;
 
                //tuitionFee
                if(this.tuitionFee.sem_total) total += this.tuitionFee.sem_total;
                if(total!='' && total!=undefined && total!=null){
                total=Number(total);
                this.tuitionFee.total=total;
                return total.toFixed(2);
                }
                return 0;
            },

            readonly() {
                return !this.permissions.editSettingsTuitionfee;
            }
        },
        mounted() {
            if (!this.permissions.viewSettingsTuitionfee) {
                return this.$router.push('/');
            }

            this.gettuitionFee();
        },
        watch: {
            'tuitionFee.semesterfees': {
               handler: function (val, oldVal) {
                   var addtototal=0;
                   for(var v in val){
                    addtototal+= Number(val[v]);
                   }
                   this.tuitionFee.sem_total=addtototal
               },
                deep: true
            },
            },
        methods: {
            changeBillingCycle(){
                this.tuitionFee.courseFee=0;
                this.tuitionFee.noOfSem=0;
                this.tuitionFee.noOfCourses=0;
                for(var i=1;i<=this.max_semesters;i++){
                    this.tuitionFee.semesterfees['semester'+i+'Fee']=null;
                }
            },

            handleInput(value) {
            value = value.replace(/^0+(?!\.|$)/, '')
                if(value!='' && (!(Number(value)>=1 && Number(value)<=20))){
                        alert('just numbers between 1 to 20 are allowed')
                        this.tuitionFee.noOfSem="";
                    }
                    else{
                        this.tuitionFee.noOfSem=value==''?value:Number(value);
                    }
                },
            handleNoOfCoursesInput(value){
            value = value.replace(/^0+/, '')
            this.tuitionFee.noOfCourses=value==''?value:Number(value);
                if(value!='' && (!(Number(value)>=1 && Number(value)<=30))){
                        alert('just numbers between 1 to 30 are allowed')
                        this.tuitionFee.noOfCourses="";
                    }
                    else{
                        this.tuitionFee.noOfCourses=value==''?value:Number(value);
                    }
                },
            chooseTuitionFee(fee){ 
                    this.tuitionFee.id = null,  
                    this.tuitionFee.ProgramType =  null,
                    this.tuitionFee.BillingCycle =  null,
                    this.tuitionFee.ApplicationFee =  0,
                    this.tuitionFee.AcceptanceFee =  0,
                    this.tuitionFee.courseFee = 0,
                    this.tuitionFee.noOfSem = 0,
                    this.tuitionFee.noOfCourses = 0,
                    this.tuitionFee.status = false,
                    this.tuitionFee.days = null,
                    this.tuitionFee.beforeOrAfter = null,
                    this.tuitionFee.semesterfees.semester1Fee = 0,
                    this.tuitionFee.semesterfees.semester2Fee = 0,
                    this.tuitionFee.semesterfees.semester3Fee = 0,
                    this.tuitionFee.semesterfees.semester4Fee = 0,
                    this.tuitionFee.semesterfees.semester5Fee = 0,
                    this.tuitionFee.semesterfees.semester6Fee = 0,
                    this.tuitionFee.semesterfees.semester7Fee = 0,
                    this.tuitionFee.semesterfees.semester8Fee = 0,
                    this.tuitionFee.semesterfees.semester9Fee = 0,
                    this.tuitionFee.semesterfees.semester10Fee = 0,
                    this.tuitionFee.semesterfees.semester11Fee = 0,
                    this.tuitionFee.semesterfees.semester12Fee = 0,
                    this.tuitionFee.semesterfees.semester13Fee = 0,
                    this.tuitionFee.semesterfees.semester14Fee = 0,
                    this.tuitionFee.semesterfees.semester15Fee = 0,
                    this.tuitionFee.semesterfees.semester16Fee = 0,
                    this.tuitionFee.semesterfees.semester17Fee = 0,
                    this.tuitionFee.semesterfees.semester18Fee = 0,
                    this.tuitionFee.semesterfees.semester19Fee = 0,
                    this.tuitionFee.semesterfees.semester20Fee = 0,
                    this.tuitionFee.total = 0,
                    this.tuitionFee.sem_total = 0
                    this.edit_enabled=true;
                    this.tuitionFee.id=fee.id;
                    this.tuitionFee.days = fee.days,
                    this.tuitionFee.beforeOrAfter = fee.beforeOrAfter;
                    this.tuitionFee.ProgramType=fee.program_type;
                    this.tuitionFee.total_fee=fee.total_fee;
                    this.tuitionFee.BillingCycle=fee.billing_cycle;
                    this.tuitionFee.noOfSem=fee.no_of_semesters;
                    this.tuitionFee.noOfCourses=fee.no_of_courses;
                    this.tuitionFee.status=fee.status;
                    const objectArray = Object.entries(fee.sem_fees);
                    var index=1;
                    objectArray.forEach(([key, value]) => {
                    this.tuitionFee.semesterfees['semester'+index+'Fee']=value.tuition_fee
                    index+=1;
                    });
                    this.tuitionFee.courseFee=fee.course_fee;
                    this.tuitionFee.ApplicationFee=fee.application_fee;
                    this.tuitionFee.AcceptanceFee=fee.administrative_fee;
            },
            gettuitionFee() {
                this.isLoading = true;

                axios
                    .get('/api/tuitionfees?page=' + this.pagination.current_page)
                    .then(response => {
                        this.tuitioinfeesarray = response.data.data.data;
                        this.pagination = response.data.data;
                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            paginate() {
                this.gettuitionFee();
            },

            update() {
                if (this.tuitionFee.id==null) {
                    this.showAlert(this.$t('form.setting.nothingToUpdate'), 'danger');
                    return;
                    }
                this.clear();
                this.isLoading = true;
                this.tuitionFee.total=this.totalFee;
                if (typeof this.tuitionFee.noOfCourses === 'string' || this.tuitionFee.noOfCourses instanceof String){
                this.tuitionFee.noOfCourses=Number(this.tuitionFee.noOfCourses);
                }
                axios
                    .put(`/api/tuitionfees/${this.tuitionFee.id}`, {
                       tuitionFee:this.tuitionFee
                    })
                    .then(response => {
                        if (response.data.success) {
                            this.showAlert(response.data.message);
                        }

                        this.isLoading = false;
                        this.gettuitionFee();
                    })
                    .catch(error => {
                        if (error.response.data.error) {
                            this.showAlert(error.response.data.message, 'danger');
                        }
                        this.isLoading = false;
                    })
            },

            cancel() {
            this.tuitionFee.id=null;
            this.tuitionFee.status=null;
            this.tuitionFee.BillingCycle=null,
            this.tuitionFee.ApplicationFee=null,
            this.tuitionFee.AcceptanceFee=null,
            this.tuitionFee.noOfSem=null,
            this.tuitionFee.noOfCourses=null,
            this.tuitionFee.courseFee=0;
            for(var i=1;i<=this.max_semesters;i++){
                this.tuitionFee.semesterfees['semester'+i+'Fee']=null;
            }
            this.tuitionFee.total=0,
            this.tuitionFee.ApplicationFee=null
            this.tuitionFee.AcceptanceFee=null

},

            remove(index) {
                if (confirm(this.$t('form.validation.delete'))) {
                    index=Number(index);
                    this.clear();
                    this.isLoading = true;
                    
                    axios.post(`/api/tuitionfees/${index}`,{_method: 'delete',id:index})
                        .then(response => {
                            if (response.data.success) {
                                this.showAlert(response.data.message);
                                if(index==Number(this.tuitionFee.id)){
                                    this.tuitionFee.BillingCycle=null,
                                    this.tuitionFee.ApplicationFee=null,
                                    this.tuitionFee.AcceptanceFee=null,
                                    this.tuitionFee.noOfSem=null,
                                    this.tuitionFee.noOfCourses=null,
                                    this.tuitionFee.courseFee=0;
                                    this.tuitionFee.status=false;
                                    for(var i=1;i<=this.max_semesters;i++){
                                        this.tuitionFee.semesterfees['semester'+i+'Fee']=null;
                                    }
                                    this.tuitionFee.total=0,
                                    this.billingCycleChanged=false
                                    this.tuitionFee.ProgramType=null;
                                    this.tuitionFee.id=null;
                                    this.edit_enabled=false;
                                }
                                this.gettuitionFee();
                            }

                            this.isLoading = false;
                        })
                        .catch(error => {
                            if (error.response.status === 422) {
                                this.showAlert(error.response.data.message, 'danger');
                            }

                            this.isLoading = false;
                        })
                }
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            },

            clear() {
                this.alert = false;
                this.message = '';
                this.alertClass = '';
            }
        }
    }

</script>
<style scoped>
.capital{
    text-transform: capitalize;
}
</style>
